import Vue from 'vue'

export default {
  getIndividualInvestment ({ commit }) {
    return Vue.axios.get('investment').then(({ data }) => commit('SET_INDIVIDUAL_INVESTMENT', data))
  },
  saveIndividualInvestment ({commit, dispatch, state}, investment) {
    return Vue.axios.put('investment', { investment })
      .then(({ data }) => {
        investment.id = data.id
        investment.promo_id = investment.promo_id ? investment.promo_id : null

        commit('UPDATE_INDIVIDUAL_INVESTMENT', investment)

        if (investment.newPhoto) {
          dispatch('loadInvestmentPhoto', { formData: investment.newPhoto, id: investment.id })
        }
        if (investment.newAboutPreview) {
          dispatch('loadInvestmentAboutPreview', { formData: investment.newAboutPreview, id: investment.id })
        }
        if (investment.newPathPreview) {
          dispatch('loadInvestmentPathPreview', { formData: investment.newPathPreview, id: investment.id })
        }

        if (investment.newRatesComparisonFile) {
          dispatch(
            'loadInvestmentRatesComparisonFile',
            { formData: investment.newRatesComparisonFile, id: investment.id }
          )
        }
      })
  },
  updateInvestmentRatesOrder ({ commit }, data) {
    commit('UPDATE_INVESTMENT_RATES', data)
    return Vue.axios.put(`investment/rates/order`, data)
  },
  loadInvestmentPhoto ({ commit }, {formData, id}) {
    return Vue.axios.post('investment/change-photo', formData)
      .then(({ data }) => commit('LOAD_INVESTMENT_PHOTO', data))
  },
  loadInvestmentAboutPreview ({ commit }, {formData, id}) {
    return Vue.axios.post('investment/change-about-preview', formData)
      .then(({ data }) => commit('LOAD_INVESTMENT_ABOUT_PREVIEW', data))
  },
  loadInvestmentPathPreview ({ commit }, {formData, id}) {
    return Vue.axios.post('investment/change-path-preview', formData)
      .then(({ data }) => commit('LOAD_INVESTMENT_PATH_PREVIEW', data))
  },
  loadInvestmentRatesComparisonFile ({ commit }, { formData, id }) {
    return Vue.axios.post('investment/change-rates-file', formData)
  },
  loadInvestmentReviewPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`investment/review/${id}/change-photo`, formData)
      .then(({ data }) => commit('CHANGE_INVESTMENT_REVIEW_PHOTO', data))
  },
  updateIndividualInvestment ({ commit }, investment) {
    commit('UPDATE_INDIVIDUAL_INVESTMENT', investment)
  },
  // advantage
  addInvestmentAdvantage ({ commit }, data) {
    commit('ADD_INVESTMENT_ADVANTAGE', data)
  },
  deleteInvestmentAdvantage ({ commit }, id) {
    commit('DELETE_INVESTMENT_ADVANTAGE', id)
  },
  updateInvestmentAdvantage ({ commit }, advantage) {
    commit('UPDATE_INVESTMENT_ADVANTAGE', advantage)
  },
  // path
  addInvestmentPath ({ commit }, data) {
    commit('ADD_INVESTMENT_PATH', data)
  },
  updateInvestmentPath ({ commit }, path) {
    commit('UPDATE_INVESTMENT_PATH', path)
  },
  deleteInvestmentPath ({ commit }, id) {
    commit('DELETE_INVESTMENT_PATH', id)
  },
  // rate
  addInvestmentRate ({ commit, state }, data) {
    commit('ADD_INVESTMENT_RATE', data)
  },
  deleteInvestmentRate ({ commit, state }, id) {
    commit('DELETE_INVESTMENT_RATE', id)
  },
  updateInvestmentRate ({ commit }, rate) {
    commit('UPDATE_INVESTMENT_RATE', rate)
  },
  // rates comparison file
  changeInvestmentRatesComparisonFile ({ commit }, file) {
    setTimeout(() => { commit('CHANGE_INVESTMENT_RATES_FILE', file) }, 200)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/individualInvestment.js